module.exports = __webpack_public_path__ + "static/media/workPvcCeilings4.ae67085d.jpg";